import { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  Autocomplete,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { UseB2BCustomer } from "./UseB2BCustomer";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditCustomer(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const [orgenizeRes, setOrgenizeRes] = useState();
  const { getOrgenizationsList, getCustomerByID, updateCustomer, validate } =
    UseB2BCustomer();
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    firstName: undefined,
    lastName: undefined,
    mobile: undefined,
    managerName: undefined,
    orgenizeName: undefined,
    comericalCode: undefined,
    orgenizeID: undefined,
    orgenizeTypeID: undefined,
    suspend: undefined,
    isColleague: undefined,
  });

  const [errorState, setErrorState] = useState({
    firstName: false,
    lastName: false,
    mobile: false,
  });

  const orgenizeType = [
    {
      id: 2,
      title: "حقوقی",
    },
    {
      id: 1,
      title: "حقیقی",
    },
  ];

  const Suspends = [
    {
      id: 0,
      title: "فعال",
    },
    {
      id: 1,
      title: "معلق",
    },
  ];

  useEffect(() => {
    getOrgenizationsList((orgenizations) => {
      setOrgenizeRes(orgenizations);
    });
  }, []);

  useEffect(() => {
    if (location.state.id) {
      getCustomerByID(
        location.state.id,
        location.state.model.mobile,
        (Customer) => {
          setState({
            id: Customer.id,
            firstName: Customer.firstName,
            lastName: Customer.lastName,
            mobile: Customer.mobile,
            managerName: Customer.managerName,
            orgenizeName: Customer.orgenizeName,
            comericalCode: Customer.comericalCode,
            orgenizeID: Customer.orgenizeID,
            orgenizeTypeID: Customer.orgenizeTypeID,
            suspend: Customer.suspend,
            isColleague: Customer.isColleague,
          });
        }
      );
    }
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "مارکتینگ",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/b2bcustomers" },
          { name: "ویرایش مشتری", url: "/b2bcustomers/editCustomer" },
        ],
      }}
    >
      {state ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.firstName ? state.firstName : ""}
              error={errorState.firstName}
              label="نام"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, firstName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.lastName ? state.lastName : ""}
              error={errorState.lastName}
              label="نام خانوادگی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, lastName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.mobile ? state.mobile : ""}
              label="شماره موبایل"
              size="small"
              variant="filled"
              sx={{ direction: "rtl" }}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            {orgenizeRes && (
              <Autocomplete
                size="small"
                value={state.orgenizeID ? state.orgenizeID : ""}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setState({ ...state, orgenizeID: newValue });
                  } else {
                    setState({ ...state, orgenizeID: undefined });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return orgenizeRes?.find((m) => m.id == option).title;
                  }
                  return "";
                }}
                fullWidth
                options={orgenizeRes?.map((m) => m.id)}
                renderInput={(params) => (
                  <TextField
                    sx={{ input: { textAlign: "center" } }}
                    variant="outlined"
                    {...params}
                    label="سازمان"
                  />
                )}
              />
            )}
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.orgenizeName ? state.orgenizeName : ""}
              label="نام سازمان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, orgenizeName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            {orgenizeType && (
              <Autocomplete
                size="small"
                value={state.orgenizeTypeID ? state.orgenizeTypeID : ""}
                onChange={(event, newValue) => {
                  if (newValue || newValue == 0) {
                    setState({ ...state, orgenizeTypeID: newValue });
                  } else {
                    setState({ ...state, orgenizeTypeID: undefined });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return orgenizeType?.find((m) => m.id == option).title;
                  }
                  return "";
                }}
                fullWidth
                options={orgenizeType.map((m) => m.id)}
                renderInput={(params) => (
                  <TextField
                    sx={{ input: { textAlign: "center" } }}
                    variant="outlined"
                    {...params}
                    label="نوع سازمان"
                  />
                )}
              />
            )}
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.managerName ? state.managerName : ""}
              label="نام مدیر"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, managerName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.comericalCode ? state.comericalCode : ""}
              label="کد اقتصادی"
              size="small"
              variant="outlined"
              sx={{ direction: "rtl" }}
              onChange={(evt) => {
                setState({ ...state, comericalCode: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <FormControlLabel
              checked={state.isColleague ? state.isColleague : false}
              onChange={(evt) => {
                setState({ ...state, isColleague: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="همکار"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateCustomer(state, () => {
                    navigate("/b2bcustomers", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/b2bcustomers", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
